export enum CondicionVentaFactura{
    indeterminado,
    contado,
    cuentaCorriente,
    previoPago
}